@switch (lastType ?? 'info') {
  @case ('info') {
    <div
      class="alert alert-info fixed bottom-20 right-5 z-[70] shadow-lg min-w-[250px] transition-all duration-500 ease-in-out pointer-events-none lg:bottom-5"
      [class.opacity-100]="alert()"
      [class.scale-100]="alert()"
      [class.pointer-events-auto]="alert()"
      [class.opacity-0]="!alert()"
      [class.scale-95]="!alert()"
      role="alert">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="h-6 w-6 shrink-0 stroke-current">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <span>{{ lastMessage }}</span>
    </div>
  }
  @case ('success') {
    <div
      class="alert alert-success fixed bottom-20 right-5 z-[70] shadow-lg min-w-[250px] transition-all duration-500 ease-in-out pointer-events-none lg:bottom-5"
      [class.opacity-100]="alert()"
      [class.scale-100]="alert()"
      [class.pointer-events-auto]="alert()"
      [class.opacity-0]="!alert()"
      [class.scale-95]="!alert()"
      role="alert">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 shrink-0 stroke-current" fill="none" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>{{ lastMessage }}</span>
    </div>
  }
  @case ('error') {
    <div
      class="alert alert-error fixed bottom-20 right-5 z-[70] shadow-lg min-w-[250px] transition-all duration-500 ease-in-out pointer-events-none lg:bottom-5"
      [class.opacity-100]="alert()"
      [class.scale-100]="alert()"
      [class.pointer-events-auto]="alert()"
      [class.opacity-0]="!alert()"
      [class.scale-95]="!alert()"
      role="alert">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 shrink-0 stroke-current" fill="none" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>{{ lastMessage }}</span>
    </div>
  }
  @case ('warning') {
    <div
      class="alert alert-warning fixed bottom-20 right-5 z-[70] shadow-lg min-w-[250px] transition-all duration-500 ease-in-out pointer-events-none lg:bottom-5"
      [class.opacity-100]="alert()"
      [class.scale-100]="alert()"
      [class.pointer-events-auto]="alert()"
      [class.opacity-0]="!alert()"
      [class.scale-95]="!alert()"
      role="alert">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 shrink-0 stroke-current" fill="none" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
      <span>{{ lastMessage }}</span>
    </div>
  }
}
